import type { ScreenDefinition, ScreenProps } from '../../contracts';
import { DocumentEditor } from '../documents/DocumentEditor';
import { StockBalance } from './StockBalance';
import { WarehouseHistory } from './WarehouseHistory';
import { PriceUpdate } from './PriceUpdate';
import './warehouse.css';

function Purchase(props: ScreenProps) { return <DocumentEditor {...props} params={{ ...props.params, mode: 'purchase', documentType: props.params?.documentType ?? 'AI' }} />; }
function Transfer(props: ScreenProps) { return <DocumentEditor {...props} params={{ ...props.params, mode: 'transfer', documentType: 'DT' }} />; }

export const screens: ScreenDefinition[] = [
  { id: 'warehouse.purchase-new', title: 'Einkauf', component: Purchase },
  { id: 'warehouse.purchase-list', title: 'Einkaufsbelege', component: WarehouseHistory },
  { id: 'warehouse.transfer-new', title: 'Lagertransfer', component: Transfer },
  { id: 'warehouse.transfer-list', title: 'Lagertransfer Belege', component: WarehouseHistory },
  { id: 'warehouse.stock', title: 'Lagerbestand Artikel', component: StockBalance },
  { id: 'warehouse.correction', title: 'Bestandserfassung', component: StockBalance },
  { id: 'warehouse.count-list', title: 'Bestandskorrektur Belege', component: WarehouseHistory },
  { id: 'warehouse.price-update', title: 'Preise aktualisieren', component: PriceUpdate },
];
